<template>
  <div :class="cn('animate-spin rounded-full border-2 border-current border-t-transparent', sizeClass, props.class)" />
</template>

<script setup>
import { computed } from 'vue'
import { cn } from '@/lib/utils'

const props = defineProps({
  size:  { type: String, default: 'md' },
  class: { type: String, default: '' },
})

const sizeClass = computed(() => ({
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-8 w-8',
}[props.size] ?? 'h-6 w-6'))
</script>
